import React, { FC } from "react";
import { Play } from "@yleisradio/yds-icons-react";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import {
  CenterFloatingButton,
  CenterFloatingWrapper
} from "../PlayButton/CenterFloatingButton";

export const DefaultPreviewPlayButton: FC = () => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  const isContinuingWatching = useStoreState.isContinuingWatching();
  const player = useStoreState.player();

  const { language } = useEmbedParametersContext();

  const ariaLabelAttrs = isContinuingWatching
    ? {}
    : {
        ["aria-keyshortcuts"]: "k",
        ["aria-label"]: i18n("toista_aria_label", { language })
      };

  return (
    <CenterFloatingWrapper>
      <CenterFloatingButton
        isMobile={device.isMobile}
        hasText={isContinuingWatching}
        onClick={() => player.play()}
        {...ariaLabelAttrs}>
        <Play />
        {isContinuingWatching && i18n("jatka", { language })}
      </CenterFloatingButton>
    </CenterFloatingWrapper>
  );
};
